import React from "react";
import logo from "../../assets/icons/logo.png";

import 'axios';
import '../Toast';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';


function TokenWaiting(){
    const location = useLocation();
    const { email } = location.state || {};

    return(
        <>
        <div className="loginHolder bg-[#F3F4F6] min-h-[100vh] flex items-center">
            <div className="formHolder bg-white md:w-1/2 lg:w-2/5 max-w-lg mx-auto my-5 p-8 rounded-lg shadow border-auth">
                <div className="logo">
                    <img alt="Zimzee" src={logo} className="logo-centered"/>
                </div>
                <h3 className="text-xl mt-10 mb-3 font-bold text-[24px]">We've sent you a login link</h3>
                <h1 data-devise--sign-in-target="magicLinkTitle" className="mt-2 mb-6 text-left text-heading-sm">
                    {/* <div>We've sent you a code</div> */}
                    <div className="text-md font-semibold text-gray-600 my-2">
                        Please Check your email ({email})
                    </div>
                </h1>
                <div className="bg-white shadow-lg rounded-md border border-coolGray-150 mb-6" data-test-id="static_alert" style={{marginBottom: "2rem"}}>
                    <div className="p-4">
                        <div className="flex items-start">
                        <div className="flex-shrink-0">
                            <i className="far fa-check-circle text-green-400 text-xl inline-block" aria-hidden="true"></i>
                        </div>
                        <div className="ml-3 w-0 flex-1 pt-0.5">
                            <p className="text-sm font-medium text-gray-900" id="alert-message">
                                You'll receive a login link via email. You can also <a href="/login" className="text-blue-600 font-semibold hover:underline">sign in with a password</a> instead.
                            </p>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="text-left">
                    <a className="text-blue-600" href="/">
                        <i className="fa fa-arrow-left mr-1" aria-hidden="true"></i><span>Back</span>
                    </a>
                </div>
                {/* <h3 className="text-xl mt-7 mb-6 font-bold text-[24px]">We've sent you a Login Link</h3> */}
                {/* <p className="text-center pt-3 pb-5">A one click password-free login link will be emailed to you.</p> */}
                {/* <p className="text-center pt-3 pb-5">A one click password-free login link will be emailed to you.</p>
                <div className="mt-4 text-center">
                    <hr className="-mb-3 border-[#394150]" />
                    <span className="inline-block bg-white text-center text-[#394150] px-3">OR</span>
                </div>
                <a href="/" type="button" className="flex justify-center py-3 mt-7" style={{border:"1px solid #D9D9D9", borderRadius: "50px",width:"100%"}}>
                    <img className="pr-3" src={magicLinkIcon} />
                    <span className="font-bold">Login with Password</span>
                </a> */}
                {/* <h4 className="text-gray-500 text-center mt-12">First time here? <a className="text-[#5587e9] text-blue-600 font-semibold hover:underline" href="/signup">Create account</a></h4> */}
            </div>
        </div>
        <ToastContainer />
        </>
    );
}

export default TokenWaiting;